import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=3230701a&scoped=true"
import script from "./Stores.vue?vue&type=script&lang=ts"
export * from "./Stores.vue?vue&type=script&lang=ts"
import style0 from "./Stores.vue?vue&type=style&index=0&id=3230701a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230701a",
  null
  
)

export default component.exports